import { useState } from 'react'
import chinhSuaVanBangProcessor from '../../../processor/chinhSuaVanBangProcessor'
import ListVanBangWithView from '../ListVanBangWithView'
import LichSuDieuChinhMotVanBang from './LichSuDieuChinhMotVanBang'

export default function LischSuDieuChinhVanBang() {
  const [visible, setVisible] = useState(false)
  const [id, setId] = useState(0)
  const toggle = () => setVisible(!visible)
  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-history',
        className: 'p-button-rounded mr-2',
        tooltip: 'Lịch sử điều chỉnh',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          toggle()
          setId(data.id)
        },
      }
    },
  ]
  return (
    <>
      <LichSuDieuChinhMotVanBang visible={visible} toggle={toggle} id={id} />
      <ListVanBangWithView
        moduleTitle="Lịch sử chỉnh sửa văn bằng"
        chucNangTitle="Lịch sử"
        getMethod={chinhSuaVanBangProcessor.getVanBangChinhSuaHistory}
        buttons={buttons}
        dontShow
      />
    </>
  )
}
